export const locale = {
  GENERAL: {
    'Hello' : '你好',
    'Lang': 'tw',
    'ChangeLang':'Eng',
    'ButtomSize': 'small',
    'Filter': '篩選',
    'SortByDist': '距離排序',
    'SortByRating' : '評價排序',
    'Price' : '價格',
    'TotalRating' : '總分 4⭐+',
    'Rating' : '評價',
  },
  DETAIL:{
    'Hint' : '根據文字評論自動計算餐廳在不同向度的表現。',
    'NotEnoughComment' : '評論不足',
    'LastPage' : '返回上一頁',
    'Close' : '關閉',
    'Reviews' : '則評論',
    'OpenInGoogle' : '在 Google Map 中開啟',
    'ReviewSummary' : '評論摘要',
    'LessComment' : '評論數過少',
    'CorrectSummary' : '您覺得這些資訊準確嗎？',
    'CorrectSummarySize' : '14px',
    'CorrectSummaryPadding' : '4px',
    'Correct' : '準確',
    'NotCorrect' : '不準確',
    'WhichIndex' : '請問您覺得是哪個指標不準確呢？',
    'AdjustStar' : '請透過右方的星星來調整您認為的分數',
    'Orgin' : '原分數',
    'After' : '您認為',
    'OtherSuggestion' : '其他想法或建議',
    'Review' : '評論',
    'NoReview' : '沒有評論',
    'All' : '所有',
    'Importance' : '重要性',
    'Time' : '時間',
    'RatingDesc' : '評價(高至低) ',
    'RatingAsc' : '評價(低至高) ',
  },
  UI:{
    'ShowMap' : '顯示地圖',
    'ShowList' : '顯示清單',
    'Search' : '搜尋',
  },
  CONSTANT:{
    'Name' : '餐廳',
  },
  ASPECT:{
    'Food' : '食物',
    'Service': '服務',
    'Atmosphere' : '氣氛',
    'Cleanliness' : '環境',
    'Value' : '價值',
  },
  QUICKDIRECT:{
    'Nearby' : '附近的餐廳',
    'NearbyText' : '附近的餐廳',
    'Food' : '食物好',
    'FoodText' : '食物好的餐廳',
    'Value': '高CP值', 
    'ValueText' : '價值好的餐廳',
    'Service': '服務好', 
    'ServiceText': '服務好的餐廳',
    'Atmosphere': '氣氛好', 
    'AtmosphereText': '氣氛好的餐廳'
  },
  FEEDBACK:{
    'ThxFeedBack' : '感謝你的回報',
    'CantFindText' : '找不到餐廳嗎？',
    'NoMatching' : '沒有符合的項目',
    'Submit' : '送出',
    'Cancel' : '取消',
    'RestaurantLabel' : '餐廳名字',
    'NoteLabel' : '備註',
    'Thanks' : '謝謝你',
  },
}


